export const GET_USER_BY_ROLE = 'users/GET_USER_BY_ROLE'
export const SET_USERS = 'users/SET_USERS'
export const CHANGE_USER_TEXT = 'users/CHANGE_USER_TEXT'

export const SET_CONTRACT = 'users/SET_CONTRACT'

export const HANDLE_IS_LOADING_USERS = 'users/HANDLE_IS_LOADING_USERS'
